import CIC_Award from '../images/tapperPage/CIC_Award Certificate.jpg';
import IIFME_Gold_Award from '../images/tapperPage/IIFME_Gold_award_certificate.png';
import Geneva_Silver_Award from '../images/tapperPage/Tapper_Geneva_Silve_ Medal_Certificate.png';

const awards = [
    {
        img: CIC_Award,
        alt: "CIC Award Certificate",
        title: "Young Innovator Award in 2022 Hong Kong Construction Industry Council (CIC) Construction Innovation Award"
    },
    {
        img: IIFME_Gold_Award,
        alt: "",
        title: "Gold Medal in 13th International Invention Fair in the Middle East (IIFME)",
    },
    {
        img: Geneva_Silver_Award,
        alt: "",
        title: "Silver Medal in 2022 International Exhibition of Inventions of Geneva",
    }
];

export default awards;